<template>
    <div class="chart-container" v-if="id && titulos && valores">
        <canvas :id="id"></canvas>
    </div>
</template>
<script>
import Chart from 'chart.js'

export default {
    props: {
        id: {
            type: String
        },

        titulos: {
            type: Array
        },

        valores: {
            type: Array
        }
    },

    data() {
        return {
            chartData: {
                labels: this.titulos,
                datasets: [
                    {
                        data: this.valores,
                        backgroundColor: [
                            '#DD1B16',
                            '#E46651',
                            '#00D8FF',
                            '#41B883'
                        ]
                    }
                ]
            },
            chartOptions: {
                responsive: true,
                maintainAspectRatio: false
            }
        }
    },

    methods: {
        montarGrafico() {
            var ctx = document.getElementById(this.id)
            var myChart = new Chart(ctx, {
                type: 'pie',
                data: this.chartData,
                options: this.chartOptions
            })
        }
    },

    mounted() {
        this.montarGrafico()
    }
}
</script>

<style>
.chart-container {
    width: 400px;
    height: 400px;
}
</style>
